export function deepClone(source) {
  if (!source && typeof source !== "object") {
    throw new Error("error arguments", "shallowClone");
  }
  const targetObj = source.constructor === Array ? [] : {};
  for (const keys in source) {
    if (source.hasOwnProperty(keys)) {
      if (source[keys] && typeof source[keys] === "object") {
        targetObj[keys] = source[keys].constructor === Array ? [] : {};
        targetObj[keys] = deepClone(source[keys]);
      } else {
        targetObj[keys] = source[keys];
      }
    }
  }
  return targetObj;
}
export function param2Obj(url) {
  const search = url.split("?")[1];
  if (!search) {
    return {};
  }
  return JSON.parse(
    '{"' +
      decodeURIComponent(search)
        .replace(/"/g, '\\"')
        .replace(/&/g, '","')
        .replace(/=/g, '":"') +
      '"}'
  );
}
export function toggleClass(element, className) {
  if (!element || !className) {
    return;
  }
  let classString = element.className;
  const nameIndex = classString.indexOf(className);
  if (nameIndex === -1) {
    classString += "" + className;
  } else {
    classString =
      classString.substr(0, nameIndex) +
      classString.substr(nameIndex + className.length);
  }
  element.className = classString;
}
export function allToggleClass(element, className) {
  if (!element || !className) {
    return;
  }
  element.className = className;
}
export function oneOf(value, validList) {
  for (let i = 0; i < validList.length; i++) {
    if (value === validList[i]) {
      return true;
    }
  }
  return false;
}
export function convertTreeData(rows, attributes) {
  var keyNodes = {},
    parentKeyNodes = {};
  for (var i = 0; i < rows.length; i++) {
    var row = rows[i];
    row.id = row[attributes.keyField];
    row.parentId = row[attributes.parentKeyField];
    // row.text = row[attributes.textField];
    row.expanded = row[attributes.expanded] ? true : false;
    row.checked = row[attributes.checked] ? true : false;
    row.indeterminate = row[attributes.indeterminate] ? true : false;
    row.children = [];

    keyNodes[row.id] = row;

    if (parentKeyNodes[row.parentId]) {
      parentKeyNodes[row.parentId].push(row);
    } else {
      parentKeyNodes[row.parentId] = [row];
    }

    var children = parentKeyNodes[row.id];
    if (children) {
      row.children = children;
    }

    var pNode = keyNodes[row.parentId];
    if (pNode) {
      pNode.children.push(row);
    }
  }
  return parentKeyNodes[attributes.rootParentId];
}
export function getUrlParam(url, name) {
  let reg = new RegExp("(\\?|&)" + name + "=([^&#]*)([&#]|$)");
  let r = (url ? url : window.location.href).match(reg);
  if (r != null && r != "undefined") return r[2];
  return "";
}

export function getFormatDate() {
  var date = new Date();
  var month = date.getMonth() + 1;
  var strDate = date.getDate();
  if (month >= 1 && month <= 9) {
    month = "0" + month;
  }
  if (strDate >= 0 && strDate <= 9) {
    strDate = "0" + strDate;
  }
  var currentDate =
    date.getFullYear() +
    "-" +
    month +
    "-" +
    strDate +
    " " +
    date.getHours() +
    ":" +
    date.getMinutes() +
    ":" +
    date.getSeconds();
  return currentDate;
}
/**
 * ����תurl����
 * @param {*} data,����
 * @param {*} isPrefix,�Ƿ��Զ�����"?"
 */
export function queryParams(
  data = {},
  isPrefix = true,
  arrayFormat = "brackets"
) {
  let prefix = isPrefix ? "?" : "";
  let _result = [];
  if (["indices", "brackets", "repeat", "comma"].indexOf(arrayFormat) == -1)
    arrayFormat = "brackets";
  for (let key in data) {
    let value = data[key];
    // ȥ��Ϊ�յĲ���
    if (["", undefined, null].indexOf(value) >= 0) {
      continue;
    }
    // ���ֵΪ���飬���д���
    if (value.constructor === Array) {
      // e.g. {ids: [1, 2, 3]}
      switch (arrayFormat) {
        case "indices":
          // ���: ids[0]=1&ids[1]=2&ids[2]=3
          for (let i = 0; i < value.length; i++) {
            _result.push(key + "[" + i + "]=" + value[i]);
          }
          break;
        case "brackets":
          // ���: ids[]=1&ids[]=2&ids[]=3
          value.forEach(_value => {
            _result.push(key + "[]=" + _value);
          });
          break;
        case "repeat":
          // ���: ids=1&ids=2&ids=3
          value.forEach(_value => {
            _result.push(key + "=" + _value);
          });
          break;
        case "comma":
          // ���: ids=1,2,3
          let commaStr = "";
          value.forEach(_value => {
            commaStr += (commaStr ? "," : "") + _value;
          });
          _result.push(key + "=" + commaStr);
          break;
        default:
          value.forEach(_value => {
            _result.push(key + "[]=" + _value);
          });
      }
    } else {
      _result.push(key + "=" + value);
    }
  }
  return _result.length ? prefix + _result.join("&") : "";
}
// 跳转到登录页面
export function toLogin(backUrl = window.location.href, isSso) {
  if (isSso) {
    loginByIframe(backUrl);
  } else {
    goLogin(backUrl);
  }
}
export function goLogin(backUrl = window.location.href) {
  // window.location.href = "/openplat-front/login"
  localStorage.setItem("backUrl", backUrl);
  const addressPre = window.LOCAL_CONFIG.ENV_URL;
  if (window.location.href.includes(".html")) {
    let userBehavior = window.location.href;
    setBehavior({ userBehavior }).then(() => {
      window.location.href = addressPre + "/login/login.html";
    });
  } else {
  const addressPre = window.LOCAL_CONFIG.ENV_URL;
    window.location.href =
      addressPre +
      "/iuc/login?login_type=2&service=" +
      encodeURIComponent(removeTicket(backUrl));
  }
}

// 通过iframe的形式进行登录
function loginByIframe(src) {
  const addressPre = window.LOCAL_CONFIG.ENV_URL;
  const iframe = document.createElement("iframe");
  iframe.style.display = "none";
  iframe.src =
    addressPre +
    "/iuc/login?login_type=2&service=" +
    encodeURIComponent(removeTicket(src));
  document.body.appendChild(iframe);
}
// 在未登录的情况下，跳到登录页面之前检测地址是否含有ticket，有，则去掉，防止来回跳转多个ticket携带问题
export function removeTicket(url) {
  if (url.indexOf("ticket") > -1) {
    return url
      .replace(/\?ticket=([^&#]*)\&/, '?')
      .replace(/\?ticket=([^&#]*)/, '')
      .replace(/\&ticket=([^&#]*)/, '')
  }
  // if (url.indexOf("?ticket") > -1) {
  //   return url.split("?ticket")[0];
  // }
  // if (url.indexOf("&ticket") > -1) {
  //   return url.split("&ticket")[0];
  // }
  return url;
}
/**
 * 判断当前时间是不是在后台返回的时间段中
 */
export function isDuringDate(beginDateStr, endDateStr) {
  var curDate = new Date(),
    beginDate = new Date(beginDateStr),
    endDate = new Date(endDateStr);
  if (curDate >= beginDate && curDate <= endDate) {
    return true;
  }
  return false;
}
/***_转驼峰***/
export function getCamelCase(str) {
  return str.replace(/_([a-z])/g, function(all, i) {
    return i.toUpperCase();
  });
}
// 获取浏览器所处设备是web端还是移动端
export function getDeviceType() {
  var uA = navigator.userAgent.toLowerCase();
  var ipad = uA.match(/ipad/i) == "ipad";
  var iphone = uA.match(/iphone os/i) == "iphone os";
  var midp = uA.match(/midp/i) == "midp";
  var uc7 = uA.match(/rv:1.2.3.4/i) == "rv:1.2.3.4";
  var uc = uA.match(/ucweb/i) == "ucweb";
  var android = uA.match(/android/i) == "android";
  var windowsce = uA.match(/windows ce/i) == "windows ce";
  var windowsmd = uA.match(/windows mobile/i) == "windows mobile";
  if (
    !(ipad || iphone || midp || uc7 || uc || android || windowsce || windowsmd)
  ) {
    return "Web";
  } else {
    return "H5";
  }
}

// 获取某个元素距离页面顶部的真实距离
export function getTrueTop(el) {
  let top = 0;
  let parent = el;
  while (parent) {
    top += parent.offsetTop;
    parent = parent.offsetParent;
  }
  return top;
}

/**
 * @desc 函数防抖
 * @param func 目标函数
 * @param wait 延迟执行毫秒数
 * @param immediate true - 立即执行， false - 延迟执行
 */
const debounce = (func, wait, immediate) => {
  let timer;
  return function() {
    let context = this,
      args = arguments;

    if (timer) clearTimeout(timer);
    if (immediate) {
      let callNow = !timer;
      timer = setTimeout(() => {
        timer = null;
      }, wait);
      if (callNow) func.apply(context, args);
    } else {
      timer = setTimeout(() => {
        func.apply(context, args);
      }, wait);
    }
  };
};
/**
 * @desc 函数节流
 * @param func 目标函数
 * @param wait 延迟执行毫秒数
 * @param options begin:true - 开始执行一次回调， end:true - 结束执行一次回调
 */
const throttle = (func, wait, options = {}) => {
  let timeout,
    previous = 0;

  return function() {
    let now = +new Date();
    let remain = wait - (now - previous);

    if (remain < 0) {
      if (previous === 0 && !options.begin) {
        previous = now;
        return;
      }

      if (timeout) {
        clearTimeout(timeout);
        timeout = null;
      }

      previous = now;
      func.call(this, arguments);
    } else if (!timeout && options.end) {
      timeout = setTimeout(() => {
        func.call(this, arguments);
        timeout = null;
      }, wait);
    }
  };
};

export default {
  debounce,
  throttle
};



// WEBPACK FOOTER //
// ./src/gtn/utils/index.js